import { useState, useEffect } from "react";

export const useTheme = () => {
  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem("theme");
    if (saved) setIsDark(saved === "dark");
  }, []);

  const toggleTheme = () => {
    const next = !isDark;
    setIsDark(next);
    localStorage.setItem("theme", next ? "dark" : "light");
    document.documentElement.classList.toggle("light", !next);
    document.body.style.backgroundColor = next ? "#07070f" : "#f8f8f5";
    document.body.style.color = next ? "#fff" : "#111";
  };

  return { isDark, toggleTheme };
};
